import React, { useEffect, useState, useRef } from "react";
import "./AdaptorTab.css";
import md from "../../images/medal-fill.svg";
import Allbook from "../Allbook/Allbook";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";

function AdaptorTab({ ebook }) {
  const [activeTab, setActiveTab] = useState("about");

  const [activeCategory, setActiveCategory] = useState(
    ebook?.ebook_category_id,
  );

  const [relatedBook,setrelatedBook] = useState(
    ebook?.related_details,
  );
  const [initialLoaded, setInitialLoaded] = useState(false);

  const [page, setPage] = useState(null);

  const [categoryId, setCategoryId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);

  const [ebookLoading, setEbookLoading] = useState(true);

  const [error, setError] = useState("");

  useEffect(() => {
    fetchPage(currentPage);
  }, [currentPage, relatedBook]);

  const fetchPage = async (pageNumber = 1) => {
    try {
      if (!initialLoaded) {
        setLoading(true);
      } else {
        setEbookLoading(true);
      }

      const response = await axios.get(`${END_URL}/ebook-store`, {
        params: {
          page: pageNumber,

          // category_id: activeCategory,

          ebooks: relatedBook,
        },
      });

      if (response.data.success) {
        setPage(response.data.data);

        setInitialLoaded(true);
      } else {
        setError("Page not found");
      }
    } catch (error) {
      console.log(error);

      setError("Failed to load page");
    } finally {
      setLoading(false);

      setEbookLoading(false);
    }
  };

  const handleRedirect = (link) => {
    if (!link) return;

    window.location.href = `/${link}`;
  };

  return (
    <div className="adaptor-container">
      <ul className="adaptor-tabs-nav">
        <li
          className={activeTab === "about" ? "active" : ""}
          onClick={() => setActiveTab("about")}
        >
          {ebook?.book_detail?.about_book_title}
        </li>
        <li
          className={activeTab === "who" ? "active" : ""}
          onClick={() => setActiveTab("who")}
        >
          {ebook?.book_detail?.who_is_for_title}
        </li>
        <li
          className={activeTab === "related" ? "active" : ""}
          onClick={() => setActiveTab("related")}
        >
          {ebook?.book_detail?.related_book_title}
        </li>

      </ul>

      {/* Tab Content Window */}
      <div className="adaptor-tab-content-row">
        {/* Left Column: Text description changes based on active tab */}
        <div className="adaptor-content-left">
          {activeTab === "about" && (
            <div dangerouslySetInnerHTML={{ __html: ebook?.about_book }} />
          )}
          {activeTab === "who" && (
            <div dangerouslySetInnerHTML={{ __html: ebook?.who_is_for }} />
          )}
          {activeTab === "related" && (
            <>
              <div dangerouslySetInnerHTML={{ __html: ebook?.related_book }} />
            </>
          )}
        </div>

        {ebook?.unlock_ebook_subcrition_title && ebook?.unlock_ebook_subcription_content && ebook?.show_subcription &&  (

          <div className="adaptor-card-right">
            <div className="card-badge-icon">

              {ebook?.unlock_ebook_subcrition_image && (
                <span>
                  <img
                    src={`${IMG_URL}/d0/${ebook?.unlock_ebook_subcrition_image}`}
                    alt=""
                  />
                </span>
              )}

              <h4>{ebook?.unlock_ebook_subcrition_title}</h4>
            </div>

            <div
              dangerouslySetInnerHTML={{
                __html: ebook?.unlock_ebook_subcription_content,
              }}
            />

            <div className="card-actions">
              <button
                className="btn-explore"
                onClick={() =>
                  handleRedirect(
                    ebook?.explore_ebook_subcripiton_link,
                  )
                }
              >
                {" "}
                {ebook?.explore_ebook_subcripiton_label}{" "}
              </button>

              <button
                className="btn-quiz"
                onClick={() =>
                  handleRedirect(ebook?.unlock_ebook_take_quiz_link)
                }
              >
                {" "}
                {ebook?.unlock_ebook_take_quiz_label}{" "}
              </button>
            </div>
          </div>

        )}
        
      </div>

      <div className="row related-books">

        <div className="relative-pro-btns">
          <h3>Related Books</h3>

          {page?.pagination?.last_page > 1 && (

            <a 
                onClick={() => {
                  setCurrentPage('all');
                }}
            
            >
              View All

            </a>

          )}
          
        </div>

        <div className="adapter-book-call">
          <Allbook
            categoryId={activeCategory}
            relatedIds={ebook?.related_details}
            ebook_list_content={""}
            ebook_data={page?.ebooks}
            ebook_free_books_label={page?.ebook_free_books_label}
          />

          {/* {page?.pagination?.last_page > 1 && (
            <div className="col-12 col-sm-12 col-md-12 ebook-pagination">
              <div className="pagination">
                <button
                  disabled={currentPage <= 1 || ebookLoading}
                  onClick={() => {
                    if (currentPage > 1) {
                      setCurrentPage((prev) => prev - 1);
                    }
                  }}
                >
                  Previous
                </button>

                {[...Array(page?.pagination?.last_page)].map((_, index) => {
                  const pageNumber = index + 1;

                  return (
                    <button
                      key={pageNumber}
                      disabled={ebookLoading}
                      className={pageNumber === currentPage ? "active" : ""}
                      onClick={() => {
                        if (pageNumber !== currentPage) {
                          setCurrentPage(pageNumber);
                        }
                      }}
                    >
                      {pageNumber}
                    </button>
                  );
                })}

                <button
                  disabled={
                    currentPage >= page?.pagination?.last_page || ebookLoading
                  }
                  onClick={() => {
                    if (currentPage < page?.pagination?.last_page) {
                      setCurrentPage((prev) => prev + 1);
                    }
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          )} */}

        </div>
      </div>
    </div>
  );
}

export default AdaptorTab;
